// extracted by mini-css-extract-plugin
export var bodySections = "_ce-8";
export var gray = "_ce-7";
export var green = "_ce-4";
export var iconContainer = "_ce-9";
export var iconWidgetContainer = "_ce-1";
export var phoneIcon = "_ce-2";
export var red = "_ce-5";
export var statusDot = "_ce-3";
export var widgetContainer = "_ce-0";
export var yellow = "_ce-6";